import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { VoucherExportCriteria } from '../models/report.model';
import { metricsReporting } from '../utils/metrics-util';
import { BaseService } from './base.service';

@Injectable()
export class VoucherReportService extends BaseService {
  public headers: HttpHeaders;
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.exportReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  reportVoucher(reportCriteria: VoucherExportCriteria) {
    const url = this.getFullUrl(this.envService.vouchersExport, null, true);
    const metrics = metricsReporting([this.envService.url, this.envService.report]);

    return this.http.post<any>(url, reportCriteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }

  cjxReportVoucher(reportCriteria: VoucherExportCriteria) {
    const url = this.getFullUrl(this.envService.cjxVouchersExport, null, true);
    const metrics = metricsReporting([this.envService.url, this.envService.report]);

    return this.http.post<any>(url, reportCriteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
